import { Avatar } from '@mui/material'
import { useStyles } from './styles'
import { Icon, TIconVariant } from '../icon'
import React from 'react'

type AppAvatar = {
  width?: number
  iconWidth?: number
  iconStyles?: React.CSSProperties
  subscriptionLevel: number
  src: string
}

export const AppAvatar = (props: AppAvatar) => {
  const { width = 35, subscriptionLevel, iconWidth = 16, src, iconStyles } = props
  const { classes } = useStyles()
  const icon: TIconVariant = subscriptionLevel === 1 ? 'roundedPlusStar' : 'roundedPlatinumStar'

  return (
    <div
      className={classes.root}
      style={{ width: `${width}px`, height: `${width}px` }}
      data-subscriptionlevel={subscriptionLevel}
    >
      <Avatar
        variant="square"
        src={src}
        sx={{ width: `${width - 4}px`, height: `${width - 4}px`, borderRadius: '4px', alignSelf: 'center' }}
      />
      {subscriptionLevel !== 0 && (
        <Icon
          view={icon}
          style={{
            position: 'absolute',
            zIndex: 2,
            width: `${iconWidth}px`,
            right: '-5px',
            bottom: '-5px',
            ...iconStyles,
          }}
        />
      )}
    </div>
  )
}
